"use client";

import { useEffect, useLayoutEffect } from "react";

/**
 * When `?embed=1` (FBT iframe preview): hide site chrome and accept parent postMessage actions.
 */
export default function ServicePageEmbedBridge() {
	// Fallback if middleware header was not applied (e.g. static export edge cases).
	useLayoutEffect(() => {
		document.documentElement.dataset.serviceEmbed = "1";
	}, []);

	useEffect(() => {
		const onMessage = (event: MessageEvent) => {
			if (event.origin !== window.location.origin) return;
			const data = event.data as { type?: string; action?: string } | null;
			if (data?.type !== "techxeed-fbt-chrome") return;
			if (data.action === "add-to-basket") {
				document
					.querySelector<HTMLButtonElement>(
						"#service-package-card #fbt-embed-add-to-basket",
					)
					?.click();
			}
		};

		window.addEventListener("message", onMessage);
		return () => window.removeEventListener("message", onMessage);
	}, []);

	return null;
}
